import {LoggedRoute} from './../logged-route'
import {
  ScienceArticlePage,
  ScienceArticleReadingAssignmentSessionReportHandler,
  ScienceAssignArticlePage,
  ScienceAssignmentsHandler,
  ScienceListingPageContainer,
  ScienceSearchOrListingPage,
  ScienceUnitPageHandler,
  ScienceWritingAssignmentReportHandler,
  ScienceReportsOverviewHandler,
} from './lazy'

export const routerV2Science = [
  {
    path: '/science-units/:scienceUnitId/articles/:articleUuid',
    element: <LoggedRoute component={ScienceArticlePage} />,
  },
  {
    path: '/science/reports/writing/:assignmentId',
    element: <LoggedRoute component={ScienceWritingAssignmentReportHandler} />,
  },
  {
    path: '/science/reports/reading/:assignmentId/students/:studentId',
    element: <LoggedRoute component={ScienceArticleReadingAssignmentSessionReportHandler} />,
  },
  {
    path: '/science-units/:pathScienceUnitId',
    element: <LoggedRoute component={ScienceUnitPageHandler} />,
  },
  {
    path: '/science-units/:pathScienceUnitId/articles/:articleUuid/assign',
    element: <LoggedRoute component={ScienceAssignArticlePage} />,
  },
  {path: '/science-units', element: <LoggedRoute component={ScienceListingPageContainer} />},
  {
    path: '/science/search',
    element: <LoggedRoute component={ScienceSearchOrListingPage} />,
  },
  {
    path: '/science/assignments',
    element: <LoggedRoute component={ScienceAssignmentsHandler} />,
  },
  {
    path: '/science/reports',
    element: <LoggedRoute component={ScienceReportsOverviewHandler} />,
  },
]
